// import lib
import { lazy } from "react";

const routes = [
  {
    path: "/user_role",
    element: lazy(() => import("../../pages/UserAccess/UserRole/index")),
  },
  {
    path: "/user_role/add",
    element: lazy(() => import("../../pages/UserAccess/UserRole/create")),
  },
  {
    path: "/user_role/edit/:id",
    element: lazy(() => import("../../pages/UserAccess/UserRole/edit")),
  },
];

export default routes;
